import { render } from "./otherSelect.vue?vue&type=template&id=2b01b33d&scoped=true"
import script from "./otherSelect.vue?vue&type=script&lang=js"
export * from "./otherSelect.vue?vue&type=script&lang=js"

import "./otherSelect.vue?vue&type=style&index=0&id=2b01b33d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b01b33d"]])

export default __exports__